import styled from 'styled-components'

import { Button } from '@blade/ui-kit'

import { OutlinedFilledCircleErrorIcon } from '../icons'

type ErrorCardProps = {
  title: React.ReactNode
  description: React.ReactNode
  actionText: React.ReactNode
  onAction: () => void
}

export const AlertCard: React.FC<ErrorCardProps> = ({
  onAction,
  actionText,
  title,
  description,
}) => {
  return (
    <Root>
      <Icon />
      <Title>{title}</Title>
      <Description>{description}</Description>
      <Button onClick={onAction} size="xs" variant="secondary">
        {actionText}
      </Button>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  justify-items: center;
  justify-content: center;
  padding-block: 16px;
  padding-inline: 16px;
  border-radius: 16px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);

  background-image: radial-gradient(
    50% 50px at 50% 0%,
    #ff3c4024 0%,
    #111 100%
  );
`

const Icon = styled(OutlinedFilledCircleErrorIcon)`
  color: var(--red-9);
  margin-bottom: 16px;
`

const Title = styled.div`
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1px;
  text-align: center;
  color: var(--text-12);

  margin-bottom: 8px;
`

const Description = styled.div`
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  color: var(--text-11);
  margin-bottom: 16px;
`
